import _ from 'lodash';
import { CALL_API } from '../../../middlewares/api';

import { HTTP_METHOD_POST, HTTP_METHOD_PUT } from '../../../constants/httpMethod';
import {
    REQUEST_PASSWORD_RESET_INIT,
    SUCCESS_PASSWORD_RESET_INIT,
    FAILURE_PASSWORD_RESET_INIT,
    REQUEST_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_COMMIT,
    FAILURE_PASSWORD_RESET_COMMIT
} from './constants';

export function passwordResetInit(form) {
    return {
        [CALL_API]: {
            endpoint: '/auth/password-reset',
            method: HTTP_METHOD_POST,
            body: form,
            types: [
                REQUEST_PASSWORD_RESET_INIT,
                SUCCESS_PASSWORD_RESET_INIT,
                FAILURE_PASSWORD_RESET_INIT
            ],
            authenticated: false
        }
    };
}

/**
 *
 * @param {*} form the form data
 * @param {*} email the email user encoded in base64
 * @param {*} token the token to identify the resetpassword init encoded in base64
 */
export function passwordResetCommit(form, email, token) {
    // Remove password confirmation field
    _.unset(form, 'confirmation');

    // add url params to body
    let body = _.assign({}, form, { email: email, token: token });

    return {
        [CALL_API]: {
            endpoint: '/auth/password-reset',
            method: HTTP_METHOD_PUT,
            body: body,
            types: [
                REQUEST_PASSWORD_RESET_COMMIT,
                SUCCESS_PASSWORD_RESET_COMMIT,
                FAILURE_PASSWORD_RESET_COMMIT
            ],
            authenticated: false
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/authentication/resetpassword/actions.js